export default "__VITE_ASSET__$z5RpkbD__"